import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    aria: {
      delete: 'Delete the document',
      see: 'See the document',
    },
    myMandate: 'My mandate',
    title: 'Add your B2B Mandate',
    uploadArea: {
      subTitle: 'or **browse** your documents',
      title: 'Drag your mandate here',
    },
    uploadError:
      'An error occurred while adding your mandate. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
  },
  fr: {
    aria: {
      delete: 'Supprimer le document',
      see: 'Voir le document',
    },
    myMandate: 'Mon mandat',
    title: 'Ajoutez votre mandat SEPA interentreprises',
    uploadArea: {
      subTitle: 'ou **parcourez** vos documents',
      title: 'Faites glisser votre mandat ici',
    },
    uploadError:
      'Une erreur est survenue en ajoutant votre mandat. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
  },
});

export default locales;
